import React, {CSSProperties, memo, ReactElement, useMemo} from "react";
import cls from './dot-icon.module.css';
import {classNames} from "../../../../../../lib/classNames/classNames";

interface DotIconProps {
    className?: string
    children?: ReactElement
    dotColor?: string
}

const DotIcon: React.FC<DotIconProps> = memo((props: DotIconProps) => {
    const {className, children, dotColor= '#2fc4f5'} = props;
    const styles = useMemo<CSSProperties>(
        () => ({backgroundColor: dotColor}),
        [dotColor],
    );

    return (
        <div
            className={classNames(cls.DotIcon, {}, [className])}
            style={styles}
        >
            {children}
        </div>
    )
})

export default DotIcon
